import { useI18n } from 'core/hooks/useI18n';

import { StyledLink } from './Error.styles';
import { AppSettings } from 'core/AppSettings';

export const ReturnHome = () => {
  const { l10n } = useI18n('app/components', 'errors');
  const href = getReturnHomeHref();
  return <StyledLink href={href}>{l10n('returnHome')}</StyledLink>;
};

/**
 * Returns "/" for private sites and "/company-alias/facility-alias" for Community sites.
 *
 * Private sites redirect to the first available facility, but community sites require
 * a company/facility to be specified. Community sites, when provides a company/facility,
 * will redirect to the first available module.
 */
function getReturnHomeHref() {
  const isPrivateSite = !AppSettings.isCommunity;
  if (isPrivateSite) return '/';
  const { companyAlias, facilityAlias } = getCompanyAndFacilityAliases();
  return `/${companyAlias}/${facilityAlias}`;
}

function getCompanyAndFacilityAliases() {
  const [companyAlias, facilityAlias] = window.location.pathname.split('/').filter(Boolean);
  if (!companyAlias || !facilityAlias) {
    throw new Error(`Invalid URL: missing company or facility alias`);
  }
  return {
    companyAlias,
    facilityAlias,
  };
}
